export default __webpack_public_path__ + "static/media/un-restoration-logo.891c13f9.png";